import React from 'react';
import { Box, Button, Typography } from '@mui/material';

/**
 * Reusable page header component for RSOC pages
 * 
 * @param {Object} props
 * @param {string} props.title - The page title
 * @param {string} props.subtitle - The page subtitle or description
 * @param {React.ReactNode} props.buttonIcon - Icon for the action button
 * @param {string} props.buttonText - Text for the action button
 * @param {string} props.buttonAction - URL or action for the button
 * @param {Function} props.buttonOnClick - Click handler for the button (optional, alternative to buttonAction)
 */
const PageHeader = ({ 
  title, 
  subtitle, 
  buttonIcon, 
  buttonText, 
  buttonAction,
  buttonOnClick
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      mb: 2,
      pt: 1,
      pb: 1.5,
      borderBottom: '1px solid #e0e0e0'
    }}>
      <Box>
        <Typography variant="h5" component="h1" sx={{ mb: 0.25, fontWeight: 500 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {(buttonText && (buttonAction || buttonOnClick)) && (
        <Button 
          variant="contained" 
          color="primary"
          size="small"
          href={buttonOnClick ? undefined : buttonAction}
          onClick={buttonOnClick}
          startIcon={buttonIcon}
          sx={{ ml: 1.5 }}
        >
          {buttonText}
        </Button>
      )}
    </Box>
  );
};

export default PageHeader; 